function centerActiveTab(tab) {
    if (window.matchMedia("(max-width: 1024px)").matches && tab) {
        tab.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
        });
    }
}
